import profile from '../other/profile';
import additionalCost from '../shared/additionalCost';
import additionalDocument from '../shared/additionalDocument';
import address from '../shared/address';
import bill from '../shared/bill';
import contact from '../shared/contact';
import discount from '../shared/discount';
import document from '../shared/document';
import notes from '../shared/notes';
import payment from '../shared/payment';
import paymentDocument from '../shared/paymentDocument';
import rentalObject from '../shared/rentalObject';

const deposit = `
    additionalCosts {
        ${additionalCost}
    }
    additionalDocuments {
        ${additionalDocument}
    }
    agreement {
        ${document}
    }
    assignedTaskInMoney
    assignedTasksCompleted
    assignedTasksInHandoverProtocol
    bankAccount {
        iban
        id
        name
    }
    bankAccountId
    # billReportBasePrice
    billingAddress {
        ${address}
    }
    billingAddressId
    billings {
        ${bill}
    }
    caseHeros
    caseId
    created
    debtorLawyer {
        ${contact}
        caseNumber
    }
    depositStatementDate
    discount {
        ${discount}
    }
    discountId
    finished
    handoverDate
    handoverProtocolExists
    id
    incomingPayments {
        ${payment}
    }
    inputCompleted
    inputOverview {
        ${document}
    }
    # interests {
    #     amount
    #     created
    #     delete
    #     endDate
    #     id
    #     percentage
    #     startDate
    # }
    lastMail
    lastOperatingCostStatement
    lastOperatingCostStatementDiff
    lastStatusChange
    monitions {
        ${paymentDocument}
    }
    nextDeadline
    ${notes}
    outgoingPayments {
        ${payment}
    }
    ownerSub
    paidLastOperatingCostStatement
    partialPayment
    partitionKey
    preparedCaseForLambdas
    previousOperatingCostPayback
    productType
    profile {
        ${profile}
    }
    referrer {
        id
        referringPartner
    }
    remainingDeposit
    rentDebt
    rentalObject {
        ${rentalObject}
    }
    rentalObjectId
    report {
        ${document}
    }
    reportBasePrice
    requestsPayments {
        ${paymentDocument}
    }
    resubmissions {
        author
        message
        remember
    }
    sales
    signatures {
        id
        signature
        tenantId
    }
    signedHandoverProtocol
    status
    type
    warning
`;

export default deposit;
